import { ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CollectionResponse } from "../../../types/ApiResults";

interface PaginatedListProps<T> {
    entities: CollectionResponse<T>;
    emptyEntitiesContent?: ReactNode;
    uploadCallback: () => Promise<void>;
    getItemElement: (value: T, index: number) => JSX.Element;
    disableUseEffect?: boolean;
}

function PaginatedList<T>(props: PaginatedListProps<T>) {
    const { t } = useTranslation();

    useEffect(() => {
        if (!props.disableUseEffect) {
            props.uploadCallback();
        }
    }, []);

    return (
        <div
            className={`relative flex flex-col gap-4 dmax2:gap-3 ${
                !props.entities.rows?.length && "justify-center"
            } w-full mb-[80px] dmax2:mb-[60px] text-center`}
        >
            {!props.entities.rows?.length ? (
                props.emptyEntitiesContent ? (
                    props.emptyEntitiesContent
                ) : (
                    <></>
                )
            ) : (
                props.entities.rows?.map(props.getItemElement)
            )}
            {props.entities.rows?.length < props.entities?.totalRows && (
                <div
                    onClick={props.uploadCallback}
                    className="button dmin2:H16B dmax2:H14B dmin2:w-[275px] dmax2:w-[231px] dmin2:h-[50px] dmax2:h-[40px] transition-all duration-300"
                >
                    <div className="mb-[2px]">{t("common.showMore")}</div>
                </div>
            )}
        </div>
    );
}

export default PaginatedList;
